export default __webpack_public_path__ + "static/media/PPI-walkway-012.2765fcb6.jpg";